module.exports = __webpack_public_path__ + "img/icon-delete.78d639d9.svg";